<lib-auth-tsi 
[production]="produccion"
[module]="nombreProyecto"
[versionApp]="versionApp"
[authForm]="authForm"
[aboutList]="aboutList"
[product]="module"
(loginEvent)="auth($event)"
(beforeInstall)="onBeforeInstall()"
/>
